<template>
  <div>
    <div class="search-prakerja-recommendation">
      <a
        id="recommendation-button"
        class="recommendation-button"
        :href="routeLink"
      >
        <img
          src="https://cdn.karier.mu/kariermu/assets/logo/prakerja-2023.webp"
          alt="prakerja-logo"
          class="prakerja-logo"
        >
        <span
          class="recommendation-text"
          :class="windowWidth < 1024 ? 'font-paragraph-6' : 'font-paragraph-3'"
        >
          <template v-if="isDefault">
            Mau upgrade skill tapi bingung mulai dari mana? Yuk, eksplor program Prakerja!
          </template>
          <template v-else-if="isKeywordContainsPrakerja">
            Cari program Prakerja? Yuk, eksplor program Prakerja sekarang.
          </template>
          <template v-else>
            Cari program Prakerja "<strong>{{ keyword }}</strong>", Klik untuk menemukan program tersebut.
          </template>
        </span>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PrakerjaRecommendation',
  props: {
    keyword: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      windowWidth: window.innerWidth
    }
  },
  computed: {
    routeLink () {
      const urlKariermuPrakerja = process.env.VUE_APP_URL_REWRITE_PRAKERJA
      if (this.isDefault) {
        return `${urlKariermuPrakerja}?utm_source=kariermu&utm_medium=homepage-search-bar&utm_content=default-suggestion`
      }
      if (this.isKeywordContainsPrakerja) {
        return `${urlKariermuPrakerja}?utm_source=kariermu&utm_medium=homepage-search-bar&utm_content=prakerja-suggestion`
      }
      return `${urlKariermuPrakerja}/program?search=${this.keyword}&utm_source=kariermu&utm_medium=homepage-search-bar&utm_content=general-suggestion`
    },
    isDefault () {
      return !this.keyword || this.keyword.length < 3
    },
    isKeywordContainsPrakerja () {
      const keywordString = this.keyword
      const prakerja = 'prakerja'

      if (keywordString.length <= prakerja.length) {
        for (let i = 2; i < keywordString.length; i++) {
          if (keywordString[i].toLowerCase() !== prakerja[i].toLowerCase()) {
            return false
          }
        }
        return true
      }
      return false
    }
  }
}
</script>

<style scoped>
.search-prakerja-recommendation {
  padding: 20px 16px;
}

.recommendation-button {
  width: 100% !important;
  display: flex;
  gap: 16px;
  min-height: 74px;
  max-width: unset;
  text-decoration: none;
}

.recommendation-button:hover {
  background-color: var(--color-neutral-300)
}

.recommendation-button.flex {
  max-width: unset;
  width: 100%;
}

.prakerja-logo {
  width: 70px;
  height: 42px;
  padding: 8.44px;
  border-radius: 10px;
  object-fit: contain;
  border: 1px solid var(--color-neutral-500);
  background-color: var(--color-neutral-100);
}

.recommendation-text {
  color: var(--color-text-primary);
  width: 382px;
  margin: 0;
  text-align: left;
}

@media screen and (min-width: 1024px) {
  .search-prakerja-recommendation {
    padding: 24px 0;
  }

  .recommendation-button {
    min-height: 80px;
    padding: 16px 24px;
  }

  .prakerja-logo {
    width: 80px;
    height: 48px;
    padding: 9.65px;
  }
}
</style>
